import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Card from 'components/Card';
import { cards } from 'sections/Benefits/Networking/data';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'sections/Benefits/Networking/components/SectionCards/SectionCards.module.scss';

const cn = classNames.bind(styles);

const SectionCards = (): ReactElement => {
  const { width: screenWidth } = useWindowSize(); 

  const cardsList = cards.map((card) => {
    return (
      <Card className={cn('card')} key={card.icon}>
        <div className={cn('card__content')}>
          <Card.Header className={cn('card__title-box')}>
            <div className={cn('card__icon')}>
              <img src={`/images/pages/Benefits/${card.icon}`} alt={card.alt} />
            </div>
            <h3 className={cn('card__title')}>{card.title}</h3>
          </Card.Header>  
          <Card.Content className={cn('card__description')}>
            <p>{card.description}</p>
          </Card.Content>
        </div>
      </Card>
    );
  });

  return (
    <section className={cn('cards')}>
      <div className={cn('container')}>
        <div className={cn('cards__title-box')}>
          {screenWidth >= 576
            ?
            <h2 className={cn('cards__title')}>
              <span>Maximise Your Business Potential</span> 
              <span>with DFA Networking</span>
            </h2>
            :
            <h2 className={cn('cards__title')}>
              Maximise Your Business Potential with DFA Networking
            </h2>
          }
          {screenWidth >= 576
            ?
            <p className={cn('cards__title-description')}>
              <span>Discover how our networking benefits can elevate your</span> 
              <span>freight forwarding operations.</span>
            </p>
            :
            <p className={cn('cards__title-description')}>
              Discover how our networking benefits can elevate your freight forwarding operations. 
            </p>
          }
        </div>
          <ul className={cn('cards__list')}>
            {cardsList}
        </ul>
      </div>
    </section>
  );
};

export default SectionCards;